<template>
    <div>
        <b-btn size="sm" class="bg-transparent border-0" @click="getPos">
            <font-awesome-icon icon="pencil-alt" class="text-dark"/>
        </b-btn>

        <c-modal centered size="lg" :tag="false" v-model="editModal" title="Edit Card Reader">
            <template>
                <div class="h6 mb-0">  Swipe from left to right on the reader screen to
see Setting button and enter admin PIN 07139
to access Admin Options menu. Select
"Generate pairing code" to get a new
Registration Code and enter it below.           </div>
                <div class="h6 mb-3 mt-2">
                    Note: MENUPOLY only supports Strip card reader at this point.
                </div>
                <b-alert :show="errors.any()" variant="danger" class="px-4">
                    <ul class="m-0 px-1">
                        <li v-for="err in errors.all()" :key="err">{{err}}</li>
                    </ul>
                </b-alert>
                <div class="mb-3">
                    <b-input-group prepend="Reader Name">
                        <b-input type="text" class="myFeild" v-model="model.POSName" v-validate="'required'" name="Reader Name" placeholder="Required"/>
                    </b-input-group>
                </div>
                <div>
                    <b-input-group prepend="Registration Code">
                        <b-input type="text" class="myFeild" v-model="model.POSCode" v-validate="'required'" name="Registration Code" placeholder="Required"/>
                    </b-input-group>
                </div>
            </template>

            <template #actions>
                <b-row class="flex-grow-1">
                    <b-col cols="4">
                        <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="editPos">
                            Save Changes
                            <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                        </b-btn>
                    </b-col>

                    <b-col cols="4">
                        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="editModal = false">
                            Cancel
                        </b-btn>
                    </b-col>

                    <b-col cols="4">
                        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="loading" @click="deletePos">
                            Delete Card Reader
                            <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                        </b-btn>
                    </b-col>
                </b-row>
            </template>
        </c-modal>
    </div>
</template>

<script>
    import CModal from "./Cmodal";
    export default {
        name: "editCardReader",
        components: {CModal},
        data () {
            return {
                editModal: false,
                loading: false,
                model: {
                    POSName: null,
                    POSCode: null
                }
            }
        },
        props: {
            restaurantId: {required: true},
            IKey: {required: true},
        },
        methods: {
            getPos () {
                const model = {
                    RestaurantID: this.restaurantId,
                    // UserID: localStorage.getItem('userID'),
                    TableIKey: this.IKey
                }
                this.$api.getRestaurant.GetRestaurantPOSs(model).then(res => {
                    if (res.success) {
                        this.editModal = true
                        this.model.POSName = res.results[0].POSName
                        this.model.POSCode = res.results[0].POSCode
                    }
                })
            },
            editPos () {
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        const model = {...this.model}
                        model.RestaurantID = this.restaurantId
                        model.UserID = localStorage.getItem('userID')
                        model.POSikey = this.IKey
                        this.loading = true
                        this.$api.getRestaurant.UpdateRestaurantPOS(model).then(res => {
                            this.loading = false
                            if (res.success) {
                                this.editModal = false
                                this.$emit('update')
                            } else {
                                this.$showError(res.message)
                            }
                        })
                    }
                })
            },
            deletePos () {
                this.$showConfirm(undefined, 'Are You Sure To Remove This Item??').then(() => {
                    const model = {
                        RestaurantID: this.restaurantId,
                        // UserID: localStorage.getItem('userID'),
                        POSikey: this.IKey
                    }
                    this.loading = true
                    this.$api.getRestaurant.DeleteRestaurantPOS(model).then(res => {
                        this.loading = false
                        if (res.success) {
                            this.editModal = false
                            this.$emit('update')
                        } else {
                            this.$showError(res.message)
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                })
            }
        }
    }
</script>

<style scoped>

</style>
